var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNlFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0667 10.6667C14.5387 12.978 12.6734 14.7907 10.3334 15.248C9.70935 15.3707 9.06269 15.3707 8.40002 15.3334C7.73735 15.3707 7.09069 15.3707 6.46669 15.248C4.12669 14.7907 2.26135 12.978 1.73335 10.6667H15.0667Z",
    fill: "#1565C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0667 5.33331H1.73335C2.26135 3.02198 4.12669 1.20931 6.46669 0.751976C7.09069 0.629309 7.73735 0.629309 8.40002 0.666642C9.06269 0.629309 9.70935 0.629309 10.3334 0.751976C12.6734 1.20931 14.5387 3.02198 15.0667 5.33331Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73335 5.33331H15.0667V10.6667H1.73335V5.33331Z",
    fill: "#ECEFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlFlag);
export default __webpack_public_path__ + "static/media/nl-flag.2bfaced0a2cfcbf601064ee21fa985df.svg";
export { ForwardRef as ReactComponent };